interface FinancePaginationProps {
  page: number;
  lastPage: number;
  total: number;
  label: string;
  onPageChange: (page: number) => void;
}

export default function FinancePagination({
  page,
  lastPage,
  total,
  label,
  onPageChange,
}: FinancePaginationProps) {
  return (
    <div className="flex items-center justify-between border-t border-slate-200 px-4 py-3">
      <p className="text-sm text-slate-500">
        Page {page} of {lastPage} · {total} {label}
      </p>
      <div className="flex gap-2">
        <button
          className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          type="button"
        >
          Previous
        </button>
        <button
          className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50"
          disabled={page >= lastPage}
          onClick={() => onPageChange(page + 1)}
          type="button"
        >
          Next
        </button>
      </div>
    </div>
  );
}
